import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'

import { IdIndexedPeople, Person, PersonData } from './types'

export const fetchPeople = createAsyncAction(
  '/scenes/Dashboard/data/people/PEOPLE_FETCH_BEGIN',
  '/scenes/Dashboard/data/people/PEOPLE_FETCH_SUCCESS',
  '/scenes/Dashboard/data/people/PEOPLE_FETCH_FAILURE'
)<{ currentPage?: number; limit?: number; searchQuery?: string }, IdIndexedPeople, Error>()

export const fetchPersonBegin = createAction(
  '/scenes/Dashboard/data/people/PERSON_FETCH_BEGIN',
  (resolve) => (personId: Person['id']) => resolve({ personId })
)

export const fetchPersonSuccess = createAction(
  '/scenes/Dashboard/data/people/PERSON_FETCH_SUCCESS',
  (resolve) => (person: Person) => resolve({ person })
)

export const fetchPersonFailure = createAction(
  '/scenes/Dashboard/data/people/PERSON_FETCH_FAILURE',
  (resolve) => (error: string) => resolve({ error })
)

export const createPersonBegin = createAction(
  '/scenes/Dashboard/data/people/PERSON_CREATE_BEGIN',
  (resolve) => (personData: PersonData) => resolve(personData)
)

export const createPersonSuccess = createAction(
  '/scenes/Dashboard/data/people/PERSON_CREATE_SUCCESS',
  (resolve) => (person: Person) => resolve({ person })
)

export const createPersonFailure = createAction(
  '/scenes/Dashboard/data/people/PERSON_CREATE_FAILURE',
  (resolve) => (personData: PersonData, error: string, isDuplicated?: boolean) =>
    resolve({ personData, error, isDuplicated })
)

export const updatePersonBegin = createAction(
  '/scenes/Dashboard/data/people/PERSON_UPDATE_BEGIN',
  (resolve) => (person: Person) => resolve({ person })
)

export const updatePersonSuccess = createAction(
  '/scenes/Dashboard/data/people/PERSON_UPDATE_SUCCESS',
  (resolve) => (person: Person) => resolve({ person })
)

export const updatePersonFailure = createAction(
  '/scenes/Dashboard/data/people/PERSON_UPDATE_FAILURE',
  (resolve) => (person: Person, error: string) => resolve({ person, error })
)

export type PeopleAction = ActionType<
  | typeof fetchPeople
  | typeof fetchPersonBegin
  | typeof fetchPersonSuccess
  | typeof fetchPersonFailure
  | typeof createPersonBegin
  | typeof createPersonSuccess
  | typeof createPersonFailure
  | typeof updatePersonBegin
  | typeof updatePersonSuccess
  | typeof updatePersonFailure
>
